import { createArrayWithBracesParser, encodedStringParser } from '../inboundParsers';
import { trimBraces } from '../inboundUtils';
import { playerIdNameParser } from './utils/playerInboundUtils';
export const RECENT_ADMIN_ACTIONS_PAYLOAD_DEFINITION = {
    shouldSplitWithBraces: true,
    definitionParts: [{ name: 'actions', parser: createArrayWithBracesParser(adminActionSummaryParser) }]
};
function adminActionSummaryParser(str) {
    const [adminPlayerStr, targetPlayerStr, encodedActionStr, encodedMemo, encodedDateStr] = trimBraces(str).split(',');
    return {
        adminPlayer: playerIdNameParser(adminPlayerStr),
        targetPlayer: playerIdNameParser(targetPlayerStr),
        actionStr: encodedStringParser(encodedActionStr),
        memo: encodedStringParser(encodedMemo),
        dateStr: encodedStringParser(encodedDateStr)
    };
}
